module.exports = __webpack_public_path__ + "img/project.f935cf88.svg";